<template>

  <aicc-schedule-modal @titleResize="onModalTitleResize" ref="detailModal" :scheduleStatus="modalScheduleStatus" :title="scheduleNameValue" :width="944" :height="761" noFoot @closed="onClosed()">
    <div >
      <ur-tab-box :defaultIdx="pageInitialData.tabIdx" ref="tabbox" shape="underline" @tab-change="tabChange"> 
          <ur-tab-content :idx="1" label="캠페인 상세">
              <!-- <outbound-bot-tab :items="sipNumberList" @descriptionChange="onDescriptionChange"/> -->
              <outbound-schedule-details :outCallSchedule="outCallSchedule" ref="scheduleDetails" />              
          </ur-tab-content>
          <ur-tab-content :idx="2" label="캠페인 통계">
              <outbound-schedule-statistics ref="statisticsTab" :outCallStatistics="outCallStatisticsProps" />              
          </ur-tab-content>
          <ur-tab-content :idx="3" label="캠페인 결과"
                          v-if="'DFH'.includes(modalScheduleStatus) && isManager">
            <outbound-schedule-result ref="resultTab"/>
          </ur-tab-content>
      </ur-tab-box>

      <div class="comm_view_wrap">
      </div>
      <div v-if="this.titleRowCnt===1" class="mrB32" /> 
      <div class="comm_btn_wrap">
        <!-- 
        1. 캠페인 상태에 따라 노출되는 항목 상이 (최종정의 : 작성중/대기중/진행중/중지/취소/완료/시스템중지(G)/시스템취소(H))
         - 작성중(A), 대기중(B) : 수정, 삭제
         - 진행중(C) : 복사, 중지, 완료
         - 중지(E) : 수정, 다시 진행, 취소, 복사
         - 완료(D), 취소(F) : 복사
        2. 수정, 중지, 취소는 Manager 이상 혹은 작성자 User 限 노출
        3. 시스템중지(G)/시스템취소(H) 복사 가능
        -->
        <div class="btn_area_modal1" style="width:100%">
          <ur-button @click="replaySchedule" class="btn btn_border btn_m"
            v-show="'E'.includes(modalScheduleStatus) && !isOutdated">{{ $t("MSG_BTN_CAMPAIGN_REPLAY") }}</ur-button>

          <ur-button @click="modifySchedule" class="btn btn_border btn_m" 
            v-show="'ABE'.includes(modalScheduleStatus) && (isSamePerson || isManager)">수정</ur-button>
          
          <ur-button @click="cancelSchedule" class="btn btn_border btn_m"
            v-show="'E'.includes(modalScheduleStatus) && (isSamePerson || isManager)">취소</ur-button>

          <ur-button @click="deleteSchedule" class="btn btn_border btn_m"
            v-show="'AB'.includes(modalScheduleStatus) && (isSamePerson || isManager)">삭제</ur-button>

          <ur-button @click="pauseSchedule" class="btn btn_border btn_m"
            v-show="'C'.includes(modalScheduleStatus) && (isSamePerson || isManager)">중지</ur-button>          

          <ur-button @click="completeSchedule" class="btn btn_border btn_m"
            v-show="'C'.includes(modalScheduleStatus) && isItemCompleted">완료</ur-button>
          
          <ur-button @click="copySchedule" class="btn btn_border btn_m"
            v-show="'CDEFGH'.includes(modalScheduleStatus) && showCopyScheduleButton">{{ $t("MSG_BTN_CAMPAIGN_COPY") }}</ur-button>          
          
        </div>
        <div class="btn_area_modal2" >
          <ur-button @click="onConfirm" shape="solid" primary>{{ $t("MSG_BTN_CFRM") }}</ur-button>
        </div>
      </div>
     
      <div>
        <ur-snackbar ref="snackbar" :duration="3000"></ur-snackbar>
      </div>
    </div>
  </aicc-schedule-modal>
</template>

<script>

import BasePage from '~cm/components/BasePage';
import OutboundScheduleDetails from '../../pages/C/components/PGE_AIC_00004_T01';
import OutboundScheduleStatistics from '../../pages/C/components/PGE_AIC_00004_T02';
import OutboundScheduleResult from '../../pages/C/components/PGE_AIC_00004_T03';

if (!window.PGE_AIC_00004_P01_POPUPMAP) {
  window.PGE_AIC_00004_P01_POPUPMAP = new Map();
}

// window.setOutCallSchduleInfoFromChild = function (mode, data) {
//   console.log("CMP_AIC_00005: Called from child PGE_AIC_00003.");
//   console.log(data)
//   modeValueFromChild = mode;
//   outCallSchduleInfoFromChild = data;
// }
// var modeValueFromChild;
// var outCallSchduleInfoFromChild;

export default {
  name: "CMP_AIC_00005",
  extends: BasePage,

  components: {
    BasePage,
    OutboundScheduleDetails,
    OutboundScheduleStatistics,
    OutboundScheduleResult,
  },

  props: {
    pageId: {
      type: String, 
      required: true,
    },
    closeDetailPopup: {
      type: Function,
      default: () => {},
    },
    pageInitialData: {
      type: Object,
      default() {
        return {};
      },
    },

  },

  data() {
    return {
      titleRowCnt:1,
      outCallScheduleAsk: {
        scheduleId: '',
      },

      outCallScheduleItemsAsk: {
        scheduleId: '',
      },

      outCallScenarioVariableAsk: {
        scenarioId: '',
      },

      outCallSchedule: {
        scheduleId: '',
        scheduleName: '',
        scheduleDescription: '',
        tenantId: '',
        userId: '',
        userNm: '',
        siteId: '',
        botId: '',
        scenarioId: '',
        scenarioName: '',
        scenarioVariables: [],
        questionNumbers: '',
        sipNumber: '',
        callerId: '',
        retryNumber: '',
        schedulePriority: '',
        scheduleStatus: '',
        excludeDayofweek: '',
        excludeHolidayYn: '',
        startDate: '',
        endDate: '',
        startTimeLimit: '',
        endTimeLimit: '',
        fstRgstDtm: '',
        fnlMdfcDtm: '',
        calleeCount: 0,
        calleeInfoList: [],
        showCalleeInfo: false,
        showCopyScheduleButton: false,
      },

      updateData: {},

      // 임시저장(A), 대기(B), 진행중(C), 종료(D), 중지(E), 취소(F)
      statusTemperary: false,
      statusReady: false,
      statusOngoing: false,
      statusEnd: false,
      statusPaused: false,
      statusCancelled: false,
      isSamePerson: false,
      isManager: false,
      isOutdated: false,
      isItemCompleted: true,

      outCallScheduleDeleteAsk: {},
      outCallScheduleStatusUpdateAsk: {},

      scheduleNameValue: '',

      updatePopupWindow: null,
      copyPopupWindow: null,
      updatePopupWindowMap: null,
      
      parentPageId: '',
      outCallStatistics: {},

      modalScheduleStatus: '',

    };
  },

  created() {      
    
  },

  computed: {
    outCallStatisticsProps(){
      let result = {
        callTotalCnt:this.outCallStatistics.callTotalCnt,
        callSuccessCnt:this.outCallStatistics.callSuccessCnt,
        callReserveCnt:this.outCallStatistics.callReserveCnt,
        callSuccessRatio:this.outCallStatistics.callSuccessRatio,
        calleeCnt:this.outCallStatistics.calleeCnt,
        callCntByCallee:this.outCallStatistics.callCntByCallee,
        callSuccessCntByCallee:this.outCallStatistics.callSuccessCntByCallee,
        callSuccessRatioByCallee:this.outCallStatistics.callSuccessRatioByCallee,
        scenarioStartCntByCallee:this.outCallStatistics.scenarioStartCntByCallee,
        scenarioEndCntByCallee:this.outCallStatistics.scenarioEndCntByCallee,
        scenarioEndRatioByCallee:this.outCallStatistics.scenarioEndRatioByCallee,
      };
      return result;
    },

    showCopyScheduleButton() {
        // 완료(D), 취소(F), 시스템취소(H) 캠페인의 경우 최종 수정일자 이후 7일 경과시 상세보기/파일다운로드 및 캠페인복사 미제공
        return this.outCallSchedule.showCopyScheduleButton;
    },
  },
  
  watch: {      
    
  },

  mounted() {
    this.updatePopupWindowMap = window.PGE_AIC_00004_P01_POPUPMAP;
    this.isManager = aiccCode.UserGroup.isManager(this.$store.getters.userInfo.userGroupId);
    
    //this.titleRowCnt = 2;
  },
  
  methods: {
    onModalTitleResize(height){
      // console.log('onModalTitleResize', height);
      if(height > 60) {
        this.titleRowCnt = 2; 
        $("dl.full").css({"min-height":"70px"})
        console.log($(".view_wrap dl.full").css("min-height")) 
      } else {
        this.titleRowCnt = 1; 
        $("dl.full").css({"min-height":"94px"}) 
      }
    },
    open(){
      //console.log(this.pageInitialData)
      this.init();
      /* var clientHeight = document.getElementById('modalTitle');  */    
      // detailModal getSchedule() 이 끝난 후 띄운다.
      // this.$refs['detailModal'].open();
    },
    close(){
      this.$refs['detailModal'].close();
    },

    onClosed() {
      // console.log('onClosed()')
      this.$emit('closeDetailPopup');
    },

    init() {
      // console.log(this.pageInitialData)
      this.parentPageId = this.pageInitialData.parentPageId;
      this.outCallScheduleAsk.scheduleId = this.pageInitialData.scheduleId;
      this.scheduleNameValue = this.pageInitialData.scheduleName;
      this.$refs.tabbox.setIdx(this.pageInitialData.tabIdx);
      this.getSchedule();
    },
    
    tabChange(index){
      if (index === 2 && this.pageInitialData.tabIdx === 1) {
        this.$refs['statisticsTab'].showChartWithData(this.outCallStatistics);
      } else if (index === 3) {
        this.$refs['resultTab'].getRecordFileStatus(this.parentPageId, this.outCallScheduleAsk.scheduleId);
      }
    },

    showSnackbar(message) {
      this.$refs.snackbar.show({text: message});
    },

    getSchedule() {
      // OutCall Schedule 한 건 가져온다.
      http.request(this.parentPageId, 'DTS_AIC_00005', {
        query: this.outCallScheduleAsk,
      }).then((response) => {
        // console.log(response.data);
        this.outCallSchedule.scheduleId = response.data.scheduleId;
        this.outCallSchedule.scheduleName = response.data.scheduleName;
        this.scheduleNameValue = response.data.scheduleName;

        this.outCallSchedule.userId = response.data.usrId;
        this.outCallSchedule.userNm = response.data.usrNm;
        this.outCallSchedule.fstRgstDtm = response.data.fstRgstDtm;
        this.outCallSchedule.fnlMdfcDtm = response.data.fnlMdfcDtm;
        this.outCallSchedule.fnlMdfcUsrId = response.data.fnlMdfcUsrId;
        this.outCallSchedule.fnlMdfcUsrNm = response.data.fnlMdfcUsrNm;

        this.outCallSchedule.scheduleStatus = response.data.scheduleStatus;

        // 완료(D), 취소(F), 시스템취소(H) 캠페인의 경우 최종 수정일자 이후 7일 경과시 상세보기/파일다운로드 및 캠페인복사 미제공
        this.outCallSchedule.showCalleeInfo = true;
        this.outCallSchedule.showCopyScheduleButton = true;
        if (this.outCallSchedule.scheduleStatus === 'D' || this.outCallSchedule.scheduleStatus === 'F' || this.outCallSchedule.scheduleStatus === 'H') {
            let lastUpdateDate = utils.toStringByFormat(this.outCallSchedule.fnlMdfcDtm, 'YYYY-MM-DD');
            let currentDate = utils.now('YYYY-MM-DD');
            let pastDays = utils.getDayOffset(currentDate, lastUpdateDate); // getDayOffset(targetDate, diffDate)
            if (pastDays > 7) {
              this.outCallSchedule.showCalleeInfo = false;
              this.outCallSchedule.showCopyScheduleButton = false;
            }
        }
        
        // 대기중이었다가 진행중으로 바뀐 경우 캠페인 관리 화면 목록 갱신
        if (this.pageInitialData.scheduleStatus === 'A' || this.pageInitialData.scheduleStatus === 'B') {
          if (response.data.scheduleStatus === 'C') {
            this.$emit('reLoadScheduleList', response.data.scheduleId, response.data.scheduleStatus);
          }
        }

        this.outCallSchedule.startDate = response.data.startDate;
        this.outCallSchedule.endDate = response.data.endDate;
        this.outCallSchedule.startTimeLimit = response.data.startTimeLimit;
        this.outCallSchedule.endTimeLimit = response.data.endTimeLimit;
        this.outCallSchedule.excludeDayofweek = response.data.excludeDayofweek;
        this.outCallSchedule.excludeHolidayYn = response.data.excludeHolidayYn;
        this.outCallSchedule.sipNumber = response.data.sipNumber;
        this.outCallSchedule.sipNumberDescription = response.data.sipNumberDescription;
        this.outCallSchedule.callerId = response.data.callerId;
        this.outCallSchedule.channels = response.data.channels;
        this.outCallSchedule.scenarioId = response.data.scenarioId;
        this.outCallSchedule.scenarioName = response.data.scenarioName;
        this.outCallSchedule.retryNumber = response.data.retryNumber;
        this.outCallSchedule.calleeCount = response.data.calleeCount;
        this.outCallSchedule.scheduleDescription = response.data.scheduleDescription;

        this.setScheduleStatusFlag(response.data.scheduleStatus);
        this.isSamePerson = false;
        if (this.$store.getters.userInfo.userId === this.outCallSchedule.userId ) {
          this.isSamePerson = true;
        }

        this.isOutdated = false;
        if (this.getNowDateTime() > (this.outCallSchedule.endDate + this.outCallSchedule.endTimeLimit)) {
          this.isOutdated = true;
        }

        this.isItemCompleted = true;
        for (var variable of response.data.outCalleeInfoList) {
          if (variable.itemStatus !== 'C') {
            this.isItemCompleted = false;
            break;
          }
        }

        // if (response.data.managerYn === 'Y') {
        //   this.managerFlag = true;
        // } else {
        //   this.managerFlag = false;
        // }
        // 수신인 정보를 가져온다.
        // this.getCalleeInfo(this.outCallScheduleAsk.scheduleId);
        this.outCallSchedule.calleeInfoList = response.data.outCalleeInfoList;

        // 시나리오별 custom 컬럼을 가져온다.
        // this.getScenarioVariable(this.outCallSchedule.scenarioId);
        this.outCallSchedule.scenarioVariables = [];
        for (var variable of response.data.scenarioVariableList) {
          this.outCallSchedule.scenarioVariables.push({"value": variable.variableName, "text": variable.variableMeaning});
        }

        this.outCallStatistics = {};
        this.outCallStatistics.callTotalCnt = response.data.schedulesStatistics.callTotalCnt;
        this.outCallStatistics.callSuccessCnt = response.data.schedulesStatistics.callSuccessCnt;
        this.outCallStatistics.callReserveCnt = response.data.schedulesStatistics.callReserveCnt;
        this.outCallStatistics.callSuccessRatio = response.data.schedulesStatistics.callSuccessRatio;
        this.outCallStatistics.calleeCnt = response.data.schedulesStatistics.calleeCnt;
        this.outCallStatistics.callCntByCallee = response.data.schedulesStatistics.callCntByCallee;
        this.outCallStatistics.callSuccessCntByCallee = response.data.schedulesStatistics.callSuccessCntByCallee;
        this.outCallStatistics.callSuccessRatioByCallee = response.data.schedulesStatistics.callSuccessRatioByCallee;
        this.outCallStatistics.scenarioStartCntByCallee = response.data.schedulesStatistics.scenarioStartCntByCallee;
        this.outCallStatistics.scenarioEndCntByCallee = response.data.schedulesStatistics.scenarioEndCntByCallee;
        this.outCallStatistics.scenarioEndRatioByCallee = response.data.schedulesStatistics.scenarioEndRatioByCallee;

        // 수정화면에 넘길 데이터를 보관해 놓는다.
        this.updateData = response.data;
        // 캠페인 상세 Tab에 있는 수신인 리스트 배열에 값을 넘긴다.
        this.$refs['scheduleDetails'].setCalleeList(this.outCallSchedule.calleeInfoList);
        
        // 캠페인 상세 팝업을 띄운다.
        this.$refs['detailModal'].open();
        this.$nextTick(
          () => {console.log('When Open', this.$refs['detailModal'].getTitleHeight());}
        );
        
        if(this.pageInitialData.tabIdx===2){
          this.$refs['statisticsTab'].showChartWithData(this.outCallStatistics);
        }

        // console.log(this.outCallSchedule);

      }).catch((error) => {
          console.warn(error);
      });
    },

    modifySchedule() {
      // 캠페인이 다른 사용자에 의해 수정 중인지 check 한다.
      this.outCallScheduleAsk.scheduleId = this.outCallSchedule.scheduleId;
      http.request(this.parentPageId, 'DTS_AIC_00024', {
        query: this.outCallScheduleAsk,
      }).then((response) => {
        // console.log(response.data)
        if (response.data.reply.code !== '0000') {
          // console.log(response.data);
          this.showSnackbar(response.data.reply.korMsg);
        } else {
          this.checkWaitingStusAndModifyPopup();
        }
      }).catch((error) => {
        console.warn(error);
      });   

    },

    checkWaitingStusAndModifyPopup() {
      let modeValue = 'U';
      // '대기' 캠페인을 수정하는 경우 서버 DB 값이 정말 '대기' 상태인지 확인한다.
      // 즉, 수정 가능한 상태인지 확인하고 '대기' 상태면 '임시저장' 상태로 상태를 바꾼다.
      this.outCallScheduleAsk.scheduleId = this.outCallSchedule.scheduleId;
      if (this.outCallSchedule.scheduleStatus === 'B') {
        // 수정창에서 '임시저장' -> '대기'로 다시 변경해야 하므로 별도 modeValue로 수정창을 띄운다.
        modeValue = 'UB';
        // 캠페인 상태가 여전히 '대기'인지 확인한다.
        http.request(this.parentPageId, 'DTS_AIC_00023', {
          query: this.outCallScheduleAsk,
          }).then((response) => {
            if (response.data.reply.code === '0000') {
              // 정상 return 인 경우 대기 상태는 이미 '임시저장'으로 변경된 상태이다.
              this.openModifyPopup(modeValue, this.outCallSchedule.scheduleId);
            } else {
              // 대기 상태가 아니라는 메시지를 보여준다.
              // console.log(response.data)
              this.showSnackbar(response.data.reply.korMsg);
              // 대기 상태에서 진행 중으로 변경되었기 때문에 상세화면과 캠페인 관리 화면을 갱신한다.
              this.outCallSchedule.scheduleStatus = response.data.scheduleStatus;
              this.setScheduleStatusFlag(this.outCallSchedule.scheduleStatus);
              this.$emit('reLoadScheduleList', this.outCallSchedule.scheduleId, this.outCallSchedule.scheduleStatus);
            }
          }).catch((error) => {
            console.warn(error);
          });
      } else {
        this.openModifyPopup(modeValue, this.outCallSchedule.scheduleId);
      }
    },

    openModifyPopup(modeValue, scheduleId) {
      // 수정모드인 경우 팝업을 scheduleId 당 하나만 띄운다.
      if (!this.updatePopupWindowMap.has(scheduleId)) {
        let updatePopupWindow = aiccUtils.newOutCallSchedulePopup(modeValue, scheduleId, 
          (event) => {           
            let params = aiccUtils.getUrlParamMap(event.target.URL);
            let scheduleId = params.scheduleId;
            this.clearPopupWindowMap(scheduleId);
            this.closeModalPopup();
           }
        );
        this.updatePopupWindowMap.set(scheduleId, updatePopupWindow);
      } else {
        let updatePopup = this.updatePopupWindowMap.get(scheduleId);
        updatePopup.focus();
      }    
    },

    onClickMessageBoxCancel() {
      // console.log('onClickMessageBoxCancel() was called.')
    },

    clearPopupWindowMap(scheduleId) {
      // console.log(scheduleId + ' deleted in updatePopupWindowMap.');
      this.updatePopupWindowMap.delete(scheduleId);
    },

    deleteSchedule() {
      // '삭제'버튼이 노출된 상태에서 시간이 경과하여 
      // 수행 시작시간이 도래 즉 캠페인이 시작되었을 경우가 발생할 수도 있으므로
      // '삭제' 버튼 클릭 시점에 한번 더 캠페인 상태가 진행 중('C')인지를 한번 더 체크한다.
      http.request(this.parentPageId, 'DTS_AIC_00005', {
        query: this.outCallScheduleAsk,
      }).then((response) => {

        if (response.data.scheduleStatus === 'C') {
          this.showSnackbar('실행 중인 캠페인은 삭제할 수 없습니다.');
          return;

        } else {
          this.outCallScheduleDeleteAsk['schedule-id'] = this.outCallSchedule.scheduleId;
          // console.log(JSON.stringify(this.outCallScheduleDeleteAsk));
          utils.aiccMessageBox('캠페인 삭제', utils.strFormat('<b>{0}</b> 캠페인을 삭제하시겠습니까? <br>* 삭제하신 캠페인은 되돌릴 수 없습니다.', this.outCallSchedule.scheduleName),
            '캠페인 삭제', () => {
            http.request(this.parentPageId, 'DTS_AIC_00015', {
              path: this.outCallScheduleDeleteAsk,
              }).then((response) => {
                if (response.data.reply.code === '0000') {
                  window.modeValueFromChild = 'D';
                  window.outCallSchduleInfoFromChild = this.outCallSchedule;
                  this.closeModalPopup();
                } else { // 캠페인 삭제시, 서버에서 캠페인 상태를 확인하여 진행이 시작된 캠페인 삭제 불가
                  utils.aiccMessageBox('확인', response.data.reply.korMsg, '확인', null);
                }
              }).catch((error) => {
                  console.warn(error);
              });
            },
            '취소', this.onClickMessageBoxCancel(),
          );

        }
      }).catch((error) => {
          console.warn(error);
      });
    },

    pauseSchedule() {
      // Status : 작성중(A), 대기(B), 실행중(C), 완료(D), 중지(E), 취소(F)
      this.changeScheduleStatus(this.outCallSchedule.scheduleId, this.outCallSchedule.scheduleName, 'E');
    },

    cancelSchedule() {
      // 스케줄 상태: 작성중(A), 대기중(B), 진행중(C), 완료(D), 중지(E), 취소(F)
      this.changeScheduleStatus(this.outCallSchedule.scheduleId, this.outCallSchedule.scheduleName, 'F');
    },

    completeSchedule() {
      // Status : 작성중(A), 대기(B), 실행중(C), 완료(D), 중지(E), 취소(F)
      this.changeScheduleStatus(this.outCallSchedule.scheduleId, this.outCallSchedule.scheduleName, 'D');
    },

    copySchedule() {
      utils.aiccMessageBox('복사', utils.strFormat('<b>{0}</b> {1}', this.outCallSchedule.scheduleName, this.$t('MSG_ALT_IS_COPY_DATA')),
        '복사', () => {
          let modeValue = 'C';
          this.copyPopupWindow = aiccUtils.newOutCallSchedulePopup(modeValue, this.updateData.scheduleId, (event) => { this.closeModalPopup(); });
        },
        '취소', this.onClickMessageBoxCancel(),
      );
    },

    replaySchedule() {
      // 스케줄 상태: 작성중(A), 대기중(B), 진행중(C), 완료(D), 중지(E), 취소(F)
      this.changeScheduleStatus(this.outCallSchedule.scheduleId, this.outCallSchedule.scheduleName, 'C');
    },

    changeScheduleStatus(scheduleId, scheduleName, scheduleStatus) {
      // 스케줄 상태: 작성중(A), 대기중(B), 진행중(C), 완료(D), 중지(E), 취소(F)
      let messageTitle = '';
      let confirmMessage = '';
      this.outCallScheduleStatusUpdateAsk.scheduleId = scheduleId;
      this.outCallScheduleStatusUpdateAsk.scheduleStatus = scheduleStatus;
      
      if (scheduleStatus === 'E') {
        messageTitle = '중지';
        confirmMessage = utils.strFormat('<b>{0}</b> 캠페인을 중지하시겠습니까?', scheduleName);
      }
      if (scheduleStatus === 'C') {
        messageTitle = '캠페인 다시 진행';
        confirmMessage = utils.strFormat('<b>{0}</b> 캠페인을 다시 진행하시겠습니까?', scheduleName);
      } 
      if (scheduleStatus === 'F') {
        messageTitle = '캠페인 취소';
        confirmMessage = utils.strFormat('<b>{0}</b> 캠페인을 취소하시겠습니까?', scheduleName);
      }
      if (scheduleStatus === 'D') {
        messageTitle = '캠페인 완료';
        confirmMessage = utils.strFormat('<b>{0}</b> 캠페인을 완료하시겠습니까?', scheduleName);
      }

      // 대기 상태 캠페인을 수정시 임시저장(작성중)으로 변경하는 경우로 확인창이나 결과 메시지는 보여주지 않는다.
      if (scheduleStatus === 'A') {
        http.request(this.parentPageId, 'DTS_AIC_00016', {
          data: this.outCallScheduleStatusUpdateAsk,
          }).then((response) => {
            if (response.data.reply.code === '0000') {
              console.log('The schedule status is changed to A');
            } else {
              console.warn('The schedule status change is faild.');
            }          
          }).catch((error) => {
            console.warn(error);
          });
      } else {

        utils.aiccMessageBox(messageTitle, confirmMessage, messageTitle, () => {
          http.request(this.parentPageId, 'DTS_AIC_00016', {
            data: this.outCallScheduleStatusUpdateAsk,
            }).then((response) => {
              // console.log(JSON.stringify(response.data));
              if (response.data.reply.code === '0000') {
                this.showSnackbar('캠페인 상태가 변경되었습니다.');

                // window.setOutCallSchduleInfoFromChild('statusChanged', this.outCallSchedule);
                window.modeValueFromChild = 'statusChanged';
                window.outCallSchduleInfoFromChild = this.outCallSchedule;

              } else {
                this.showSnackbar('캠페인 상태 변경에 실패했습니다.');
              }          
              this.getSchedule();                  
            }).catch((error) => {
              console.warn(error);
            });
          },
          '취소', this.onClickMessageBoxCancel()
        );
      }
    },

    onConfirm() {
      // '확인' 버튼 누른 경우 상세조회 모달을 닫는다.
      this.closeModalPopup();
    },

    // windowPopupClosed() {
    //   // 수정, 복사 화면의 callback 함수. 상세조회 모달을 close하고 캠페인 관리화면으로 이동한다.
    //   this.closeModalPopup();
    //   // utils.goPage('PGE_AIC_00004');
    // },    
    
    closeModalPopup() {
      this.$emit('closeDetailPopup');
      this.close();
    },

    setScheduleStatusFlag(scheduleStatus) {
      // aicc-schedule-modal 에 status를 넘긴다.
      this.modalScheduleStatus = scheduleStatus;

      // 스케쥴 status에 따라 flag 를 세팅한다.
      // Status : 작성중(A), 대기(B), 실행중(C), 완료(D), 중지(E), 취소(F)
      this.statusTemperary = false;
      this.statusReady = false;
      this.statusOngoing = false;
      this.statusEnd = false;
      this.statusPaused = false;
      this.statusCancelled = false;

      switch (scheduleStatus) {
        case "A":
          this.statusTemperary = true;
          break;
        case "B":
          this.statusReady = true;
          break;
        case "C":
          this.statusOngoing = true;
          break;
        case "D":
          this.statusEnd = true;
          break;
        case "E":
          this.statusPaused = true;
          break;
        case "F":
          this.statusCancelled = true;
          break;
        default:          
      }

    },

    getNowDateTime() {
      var today= new Date();
      var year = today.getFullYear();
      var month = ("0" + (today.getMonth() + 1)).slice(-2);
      var day = ("0" + today.getDate()).slice(-2);
      var hh = ("0" + today.getHours()).slice(-2);
      var mm = ("0" + today.getMinutes()).slice(-2);
      var result = year + month + day + hh + mm;
      return result;
    },
  },

};
</script>
<style scoped>
  .comm_btn_wrap{
    justify-content: unset;
    margin: 0;
  }
  .mrB32{
    margin-bottom: 32px ;
}
  ::v-deep .ur-modal__container.ur-modal__container--medium > .ur-modal__head  {
    border-radius: 10px;
    position: inherit;
    padding: 0;
    max-height: 116px;
    min-height: 80px;
    margin-bottom: 0;
    height: auto;
  }
  ::v-deep .ur-modal__container.ur-modal__container--medium > .ur-modal__body  {    
    position: inherit;
    padding-top: 0;
    margin-top:0;
  }
 ::v-deep .ur-modal__container ur-modal__container--medium > .ur-modal__head > .ur-tab__content-wrapper {
    height: calc(100% - 48px);
    position: inherit;
}
.modal_body{
  max-height: 480px;
}

</style>
